<template>
  <div style="width: 94% !important; margin-left: 3% !important">
    <v-card-text
      class="common-autocomplete pa-0"
      :class="isSmallDevice ? 'small-device' : ''"
    >
      <v-col
        class="pa-0 form-label"
        cols="6"
        style="
          font-weight: bold !important;
          display: inline-flex !important;
          vertical-align: top !important;
          margin-top: 10px;
        "
        >{{ labelName }}
      </v-col>
      <v-col class="pa-0" style="display: inline-flex !important" cols="6">
        <v-autocomplete
          class="pa-0"
          v-model="selected"
          :items="items"
          :loading="isLoading"
          :search-input.sync="search"
          :required="!notRequired"
          :label="itemMessage"
          item-text="structured_formatting.main_text"
          item-value="place_id"
          @change="onChange"
          @clear="onClear"
          append-icon=""
          maxlength="5"
          flat
          clearable
          hide-no-data
          hide-details
          hide-selected
          return-object
          :rules="createItemRules"
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title
                v-text="item.structured_formatting.main_text"
              ></v-list-item-title>
              <v-list-item-subtitle
                v-text="item.structured_formatting.secondary_text"
              ></v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>
    </v-card-text>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { ApiUrl } from "@/config/ApiUrl";

export default Vue.extend({
  name: "AutoCompleteTextField",
  props: {
    labelName: String,
    isClickable: Boolean,
    itemMessage: String,
    notRequired: Boolean,
    isSmallDevice: Boolean,
    defaultValue: String,
    itemRules: Array,
    maxlength: Number,
    componentType: {
      type: String,
      validator: (prop) => [
        'zipcode',
        'address'
      ].includes(prop)
    }
  },
  data: () => {
    return {
      textField: "",
      isLoading: false,
      items: [],
      selected: null,
      search: null,
      tab: null,
      url: ""
    };
  },
  computed: {
    createItemRules() {
      let rules = [v => !!v || this.$props.itemMessage];
      if (!this.$props.notRequired) {
        if (this.$props.itemRules) {
          rules = rules.concat(this.$props.itemRules);
        }
        return rules;
      } else {
        return [];
      }
    }
  },
  mounted() {
    if(this.componentType.toLowerCase() === 'zipcode') {
      this.url = `${ApiUrl.SEARCH_ZIPCODE}`;
    } else if(this.componentType.toLowerCase() === 'address') {
      this.url = `${ApiUrl.SEARCH_ADDRESS}`;
    } else {
      throw "Error: Invalid value for componentType. The comonentType can be 'zipcode' or 'address' "
    }
    if (this.defaultValue && this.defaultValue !== "") {
      axios
        .request({
          method: "POST",
          url: this.url,
          data: {
            query: this.defaultValue
          }
        })
        .then(res => {
          this.items = res.data.predictions;
          this.selected = this.items[0];
        })
        .catch(err => {
          //console.log(err);
        })
        .finally(() => (this.isLoading = false));
    }
  },
  watch: {
    search(val) {
      if(val && val.length >= 6){
        this.maxInputChars = true;
      }
      this.isLoading = true;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.timer = setTimeout(() => {
        const payload = {
          query: val
        };
        axios
          .request({
            method: "POST",
            url: this.url,
            data: payload
          })
          .then(res => {
            this.items = res.data.predictions;
          })
          .catch(err => {
            //console.log(err);
          })
          .finally(() => (this.isLoading = false));
      }, 400);
    }
  },
  methods: {
    onChange() {
      let result = {
        zipCode: "",
        city: ""
      };
      if (this.selected) {
        const city = this.selected
          ? this.selected.structured_formatting.secondary_text.split(",")
          : "";
        result = {
          zipCode: this.selected.structured_formatting.main_text,
          city: Array.isArray(city) ? city[0] : ""
        };
      }
      this.$emit("set-text-value", result);
    },
    onClear() {
      this.$emit("clear-text-value");
    }
  }
});
</script>

<style lang="css" scoped>
.error-text >>> .v-label {
  color: #f58686 !important;
}
.common-autocomplete >>> .v-label {
  right: 0.4rem !important;
  left: auto !important;
  font-size: 0.85rem;
  max-width: 100% !important;
  color: #9e9e9e;
}
.common-autocomplete >>> input {
  font-size: 0.9rem !important;
  text-align: right !important;
}
.common-autocomplete >>> .v-text-field .v-select__slot {
  font-size: 0.9rem !important;
  text-align: right !important;
}
.common-autocomplete >>> .v-input__slot {
  margin-bottom: 8px;
}
.common-autocomplete >>> .v-input__slot:before {
  border-style: none !important;
  display: none !important;
}
.common-autocomplete >>> .v-input__slot:after {
  border-style: none !important;
}
.common-autocomplete >>> .v-text-field .v-label--active {
  display: none !important;
}
.common-autocomplete >>> .v-text-field__details {
  display: none !important;
}
.common-autocomplete.small-device >>> * {
  font-size: 0.8rem !important;
}
</style>
